import { render, staticRenderFns } from "./TagCRUD.vue?vue&type=template&id=79c5bffe&scoped=true&"
import script from "./TagCRUD.vue?vue&type=script&lang=ts&"
export * from "./TagCRUD.vue?vue&type=script&lang=ts&"
import style0 from "./TagCRUD.vue?vue&type=style&index=0&id=79c5bffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5bffe",
  null
  
)

export default component.exports